import React from 'react';
import Icon from '../Icon';
import svg from '../icons/tick.js';

const IconTick = (props) => <Icon {...props} svg={svg} />;

IconTick.displayName = 'IconTick';

export default IconTick;
